export const HOME_PAGE = 'HOME_PAGE';
export const ORDER_PAGE = 'ORDER_PAGE';
export const ORDERHISTORY_PAGE = 'ORDERHISTORY_PAGE';
export const PLANNING_PAGE = 'PLANNING_PAGE';
export const HELP_PAGE = 'HELP_PAGE';
export const ORDERINFO_PAGE = 'ORDERINFO_PAGE';
export const CNCINFO_PAGE = 'CNCINFO_PAGE';
export const SET_ORDERHIST_SEARCH = 'SET_ORDERHIST_SEARCH';
export const SET_PRODORDERHIST_SEARCH = 'SET_PRODORDERHIST_SEARCH';
export const SET_PLANNING_SEARCH_DATE = 'SET_PLANNING_SEARCH_DATE';